import React from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";

import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";

import {
  FaArrowRight,
  FaUsers,
  FaGraduationCap,
  FaLock,
  FaHeadset,
  FaEye,
  FaFileAlt,
  FaCalendarAlt,
  FaUserFriends,
  FaShieldAlt,
} from "react-icons/fa";

function Home() {
  const navigate = useNavigate();

  /* =========================================================
     START NEW REGISTRATION
  ========================================================= */

  return (
    <div className="home-page">

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <Navbar />


      {/* =====================================================
          HERO SECTION
      ===================================================== */}

      <section className="home-hero">

        {/* Background decorative circles */}

        <div className="hero-bg-circle hero-bg-circle-one"></div>

        <div className="hero-bg-circle hero-bg-circle-two"></div>

        <div className="hero-bg-circle hero-bg-circle-three"></div>


        <div className="hero-container">


          {/* =================================================
              LEFT SIDE
          ================================================= */}

          <div className="hero-content">

            <h1>
              Together, We Build
              <br />
              <span>A Stronger Tomorrow.</span>
            </h1>


            <p className="hero-description">
               ABNB Seva Samithi &amp; Vidya Charitable Trust
            is committed to supporting families through welfare
            programs, membership services, education assistance
            and transparent community development.
            </p>


            {/* =================================================
                DONATE BUTTON
            ================================================= */}

            <button
              type="button"
              className="donate-btn"
              onClick={() => navigate("/donate")}
            >
              Donate Now
              <FaArrowRight />
            </button>


            {/* =================================================
                MINI BENEFITS
            ================================================= */}

            <div className="hero-mini-benefits">


              {/* Education */}


              {/* Welfare */}


              {/* Security */}


            </div>

          </div>


          {/* =================================================
              RIGHT SIDE
          ================================================= */}

          <div className="hero-visual">


            {/* Large background ring */}

            <div className="hero-image-ring"></div>


            {/* =================================================
                FAMILY IMAGE
            ================================================= */}

            <div className="hero-family-image">

              <img
                src="/images/family-picture.png"
                alt="Father, mother, boy and girl"
              />

            </div>


            {/* =================================================
                MESSAGE CIRCLE
            ================================================= */}

            <div className="hero-message-card">

              <strong>
                Education
                <br />
                Welfare
                <br />
                Security
              </strong>

              <span>
                For All
              </span>

            </div>


            {/* =================================================
                IMAGE BOTTOM FEATURES
            ================================================= */}

            <div className="hero-family-features">


              {/* Education */}

              <div className="hero-family-feature">

                <div className="family-feature-icon">
                  <FaGraduationCap />
                </div>

                <strong>
                  Education
                </strong>

                <span>
                  For a Brighter Future
                </span>

              </div>


              {/* Welfare */}

              <div className="hero-family-feature">

                <div className="family-feature-icon">
                  <FaUsers />
                </div>

                <strong>
                  Welfare
                </strong>

                <span>
                  For Stronger Families
                </span>

              </div>


              {/* Security */}

              <div className="hero-family-feature">

                <div className="family-feature-icon">
                  <FaShieldAlt />
                </div>

                <strong>
                  Security
                </strong>

                <span>
                  For Generations
                </span>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY BECOME A MEMBER
      ===================================================== */}

      <section className="why-section">

        <div className="why-bg-circle why-bg-left"></div>

        <div className="why-bg-circle why-bg-right"></div>

        <div className="home-container">

          <div className="why-heading">

            <h2>
              Why <strong>Become a Member?</strong>
            </h2>

            <p>
              Join a trusted community and get access to exclusive
              benefits designed for you and your family.
            </p>

          </div>


          {/* =================================================
              BENEFIT CARDS
          ================================================= */}

          <div className="modern-benefits-grid">


            {/* CARD 01 */}

            <div className="modern-benefit-card benefit-card-blue">

              <div className="benefit-top-shape">

                <span className="benefit-number">
                  01
                </span>

              </div>

              <div className="modern-benefit-icon">
                <FaUsers />
              </div>

              <h3>
                Family Support
              </h3>

              <p>
                Welfare services and support programs for
                members and their families.
              </p>

            </div>


            {/* CARD 02 */}

            <div className="modern-benefit-card benefit-card-yellow">

              <div className="benefit-top-shape">

                <span className="benefit-number">
                  02
                </span>

              </div>

              <div className="modern-benefit-icon">
                <FaGraduationCap />
              </div>

              <h3>
                Education Support
              </h3>

              <p>
                Educational assistance, scholarships and
                skill development opportunities.
              </p>

            </div>


            {/* CARD 03 */}

            <div className="modern-benefit-card benefit-card-green">

              <div className="benefit-top-shape">

                <span className="benefit-number">
                  03
                </span>

              </div>

              <div className="modern-benefit-icon rupee-icon">
                ₹
              </div>

              <h3>
                Financial Security
              </h3>

              <p>
                Membership benefits designed for long-term
                stability and growth.
              </p>

            </div>


            {/* CARD 04 */}

            <div className="modern-benefit-card benefit-card-red">

              <div className="benefit-top-shape">

                <span className="benefit-number">
                  04
                </span>

              </div>

              <div className="modern-benefit-icon">
                <FaUserFriends />
              </div>

              <h3>
                Community Network
              </h3>

              <p>
                Be part of a growing community of
                like-minded families.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          LATEST NEWS & EVENTS
      ===================================================== */}

      <section className="news-section">

        <div className="home-container">


          {/* Section heading */}

          <div className="news-section-header">

            <div>

              <h2>
                Latest <strong>News & Events</strong>
              </h2>

              <p>
                Stay updated with our latest initiatives,
                events and announcements.
              </p>

            </div>


            <button
              type="button"
              onClick={() => navigate("/news")}
            >
              VIEW ALL
              <FaArrowRight />
            </button>

          </div>


          {/* News cards */}

          <div className="news-grid">


            {/* =================================================
                NEWS 1
            ================================================= */}

            <article className="news-card">

              <div className="news-image">

                <img
                  src="/images/news-membership.jpg"
                  alt="New Membership Drive Launched"
                />

                <span>
                  NEWS
                </span>

              </div>

              <div className="news-content">

                <h3>
                  New Membership Drive Launched
                </h3>

                <p>
                  Join our growing community and help us
                  create a better future for families in need.
                </p>

                <small>
                  <FaCalendarAlt />
                  May 15, 2024
                </small>

              </div>

            </article>


            {/* =================================================
                NEWS 2
            ================================================= */}

            <article className="news-card">

              <div className="news-image">

                <img
                  src="/images/news-education.jpg"
                  alt="Education Support Program"
                />

                <span className="event-label">
                  EVENT
                </span>

              </div>

              <div className="news-content">

                <h3>
                  Education Support Program
                </h3>

                <p>
                  Providing educational assistance to
                  deserving students.
                </p>

                <small>
                  <FaCalendarAlt />
                  May 10, 2024
                </small>

              </div>

            </article>


            {/* =================================================
                NEWS 3
            ================================================= */}

            <article className="news-card">

              <div className="news-image">

                <img
                  src="/images/news-meeting.jpg"
                  alt="Annual General Meeting"
                />

                <span>
                  NEWS
                </span>

              </div>

              <div className="news-content">

                <h3>
                  Annual General Meeting
                </h3>

                <p>
                  Our Annual General Meeting and
                  community gathering.
                </p>

                <small>
                  <FaCalendarAlt />
                  May 5, 2024
                </small>

              </div>

            </article>

          </div>

        </div>

      </section>


      {/* =====================================================
          TRUST STRIP
      ===================================================== */}

      <section className="trust-strip">


        {/* Secure */}

        <div className="trust-item">

          <FaLock />

          <div>

            <strong>
              Secure & Trusted
            </strong>

            <span>
              Bank level security with AES-256 encryption
            </span>

          </div>

        </div>


        {/* Support */}

        <div className="trust-item">

          <FaHeadset />

          <div>

            <strong>
              24/7 Support
            </strong>

            <span>
              We are here to help you anytime
            </span>

          </div>

        </div>


        {/* Transparent */}

        <div className="trust-item">

          <FaEye />

          <div>

            <strong>
              Transparent System
            </strong>

            <span>
              100% transparency in operations
            </span>

          </div>

        </div>


        {/* Easy process */}

        <div className="trust-item">

          <FaFileAlt />

          <div>

            <strong>
              Easy Online Process
            </strong>

            <span>
              Simple steps to become a member
            </span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ===================================================== */}

     
      <Footer />
    </div>
  );
}

export default Home;